import {CustomImport} from "../interfaces/custom-import";
import { Serializer } from "../interfaces/serializer";
import {BehaviorSubject} from "rxjs";
import {CustomImportMappingItemComponentObject} from "./custom-import-mapping-item-component-object";
import {DimensionComponentObjects} from "./dimension-component-object";
import {MetricComponentObjects} from "./metric-component-object";

export interface CustomImportConfiguration {
  active: boolean;
  date_mode: 'file_name' | 'date_column'
  date_parameters: {format: "%Y_%m_%d"}
  file_type: "csv"
  import_method: "email"
  import_type: "regular"
  mapping: [{ext_name: "Device", type: "DataSourceDimension", id: 532}]
  name: "test mail date mail import"
  parameters: {original_file_name: "new_report_2025_03_05.csv"}
  aggregation_type: "aggregate"
  currency: "EUR"
  file_separator: ","
  headers_line: 0
  local_file_name: "./data/test mail date-upload-1-1741181691.csv"
  mail_hash: "a450c4d042a5aa3b2773b139b8a6da36"
  original_file_name: "new_report_2025_03_05.csv"
  reject_last_row: false
  sheet: 0
}

export class CustomImportComponentObject {
  public payload: Serializer<CustomImport>;

  public readonly import_method$: BehaviorSubject<string> = new BehaviorSubject(null);
  public readonly import_type$: BehaviorSubject<string> = new BehaviorSubject(null);
  public readonly date_mode$: BehaviorSubject<string> = new BehaviorSubject(null);
  public readonly date_format$: BehaviorSubject<string> = new BehaviorSubject(null);
  public readonly dimensions$: BehaviorSubject<CustomImportMappingItemComponentObject[]> = new BehaviorSubject([]);
  public readonly nbDimensions$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public readonly metrics$: BehaviorSubject<CustomImportMappingItemComponentObject[]> = new BehaviorSubject([]);
  public readonly nbMetrics$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public readonly currency$: BehaviorSubject<string> = new BehaviorSubject(null);

  constructor(payload: Serializer<CustomImport>) {
    this.payload = payload;

    this.import_method$.next(payload.relationships.custom_import_configuration.data.attributes.import_method);
    this.import_type$.next(payload.relationships.custom_import_configuration.data.attributes.import_type);
    this.date_mode$.next(payload.relationships.custom_import_configuration.data.attributes.date_mode);

    // MAPPING
    this.dimensions$.next(
      payload.relationships.custom_import_configuration.data.attributes.mapping
        .filter((item: any): boolean => item.type === 'DataSourceDimension')
        .map((item: any) => new CustomImportMappingItemComponentObject(item))
    );

    switch (payload.relationships.custom_import_configuration.data.attributes.date_mode) {
      case 'date_column':
        this.dimensions$.value.unshift(new CustomImportMappingItemComponentObject({ ext_name: payload.relationships.custom_import_configuration.data.attributes.date_parameters.column, type: 'DataSourceDimension', ext_format: payload.relationships.custom_import_configuration.data.attributes.date_parameters.format, date: true }));
        this.date_format$.next(this.getDateFormat(payload.relationships.custom_import_configuration.data.attributes.date_parameters.format));
        break;
      case 'file_name':
        this.date_format$.next('yyyy_mm_dd');
        break;
    }

    this.nbDimensions$.next(this.dimensions$.value.length);

    this.metrics$.next(
      payload.relationships.custom_import_configuration.data.attributes.mapping
        .filter((item: any): boolean => item.type === 'DataSourceMetric')
        .map((item: any) => new CustomImportMappingItemComponentObject(item))
    );

    this.nbMetrics$.next(this.metrics$.value.length);
    this.currency$.next(payload.relationships.custom_import_configuration.data.attributes.currency);
  }

  public initDimensions(generalDimensions: DimensionComponentObjects, datasetDimensions: DimensionComponentObjects): void {
    this.dimensions$.value.forEach((dimension: CustomImportMappingItemComponentObject): void => dimension.initDimensions(generalDimensions, datasetDimensions));
  }

  public initMetrics(datasetMetrics: MetricComponentObjects): void {
    this.metrics$.value.forEach((metric: CustomImportMappingItemComponentObject): void => metric.initMetrics(datasetMetrics));
  }

  private getDateFormat(format: string): string {
    switch (format) {
      case '%Y-%m-%d':
        return 'yyyy-mm-dd';
      case '%d-%m-%Y':
        return 'dd-mm-yyyy';
      case '%m-%d-%Y':
        return 'mm-dd-yyyy';
      case '%Y/%m/%d':
        return 'yyyy/mm/dd';
      case '%d/%m/%Y':
        return 'dd/mm/yyyy';
      case '%m/%d/%Y':
        return 'mm/dd/yyyy';
    }
  }

}
